// Returns true, if the environment is production.
const isProduction: boolean =
  process.env.NODE_ENV && process.env.NODE_ENV === "production";

// Returns true, if the environment is development.
const isDevelopment: boolean =
  process.env.NODE_ENV && process.env.NODE_ENV === "development";

const hostname: string = isProduction
  ? window.location.hostname
  : process.env.REACT_APP_DEV_API_HOSTNAME || "future.teambeam.dev";

const basePath: string = "/api/skp";

const basePathV1: string = `${
  process.env.REACT_APP_API_BASEPATH ?? basePath
}/v1`;

const basePathV2: string = `${
  process.env.REACT_APP_API_BASEPATH ?? basePath
}/v2`;

const skalioIDBasePath: string = "/api/id/v3";

export {
  basePathV1,
  basePathV2,
  hostname,
  isDevelopment,
  isProduction,
  skalioIDBasePath,
};
